import React from "react";

interface RefreshIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
}

const RefreshIcon: React.FC<RefreshIconProps> = ({
  size = 15,
  color = "#FF6D41",
  strokeWidth = 1.3,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M13.9834 7.31706C13.9834 10.9971 10.9967 13.9837 7.31669 13.9837C3.63669 13.9837 1.39002 10.2771 1.39002 10.2771M1.39002 10.2771H4.40336M1.39002 10.2771V13.6104M0.650024 7.31706C0.650024 3.63706 3.61002 0.650391 7.31669 0.650391C11.7634 0.650391 13.9834 4.35706 13.9834 4.35706M13.9834 4.35706V1.02372M13.9834 4.35706H11.0234"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RefreshIcon;
